import { FaWhatsapp } from "react-icons/fa";

export default function WhatsAppChat() {
  return (
    <a
      href="https://wa.me/918800229968?text=Hi%20I%20came%20from%20your%20website"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 bg-green-500 p-4 rounded-full text-white shadow-lg hover:scale-110 transition"
      aria-label="Chat on WhatsApp"
    >
      <FaWhatsapp size={28} />
    </a>
  );
}
